module.exports = __webpack_public_path__ + "static/img/product.fw.7fd6535.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product.fw.png
// module id = 8V3c
// module chunks = 1